const onboardingPageMessages = {
  TITLE: 'Welcome to Homa Health, Complete Your Onboarding. ',
  FILE_UPLOADER: {
    TITLE: (_fileName: string) => `Upload your ${_fileName} file`,
    SUBTITLE:
      'Medical file has the list of employees and their healthcare provider history. ',
  },
  UPLOAD_TABS: ['Medical', 'RX', 'Census', 'Point Solutions', 'Contracts'],
};

export default onboardingPageMessages;
